import { makeThemeColor, TERTIARY, PRIMARY } from '@tornado-rdk/theme';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { FONT } from '@tornado-rdk/typography';

export const BORDER_RADIUS = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const BORDER_WIDTH = {
  [HD]: 4,
  [FULL_HD]: 6,
};

export const HEIGHT = {
  [HD]: 56,
  [FULL_HD]: 64,
};

export const PADDING = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const ICON_WIDTH = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const ICON_HEIGHT = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const ICON_PADDING_LEFT = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const DEFAULT_BUTTON_WIDTH = {
  [HD]: 56,
  [FULL_HD]: 64,
};

export const LABEL_FONT = FONT.OTTAWA_2;

export const UNFOCUSED_BACKGROUND_COLOR = makeThemeColor(TERTIARY, 0.6);

export const UNFOCUSED_CONTENT_COLOR = makeThemeColor(PRIMARY);

export const UNFOCUSED_INNER_BORDER_COLOR = makeThemeColor(PRIMARY, 0.3);

export const UNFOCUSED_OUTER_BORDER_COLOR = makeThemeColor(PRIMARY, 0);

export const FOCUSED_BACKGROUND_COLOR = makeThemeColor(PRIMARY);

export const FOCUSED_CONTENT_COLOR = makeThemeColor(TERTIARY);

export const FOCUSED_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const FOCUSED_OUTER_BORDER_COLOR = makeThemeColor(PRIMARY);

export const LOADING_BACKGROUND_COLOR = makeThemeColor(TERTIARY, 0.3);

export const LOADING_BAR_COLOR = makeThemeColor(PRIMARY);

export const LOADING_CONTENT_COLOR = makeThemeColor(TERTIARY);

export const LOADING_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const LOADING_OUTER_BORDER_COLOR = makeThemeColor(PRIMARY, 0);
